export function hasNodeIgnoreClassName(el: HTMLElement | null, ignoreClass: string = '') {
    if (!el) return false;
    // Start from the current element
    let ignoreClickOutside = el.classList.contains(ignoreClass);
    let parentEl = el.parentElement;

    // Loop until we reach the top of the DOM
    while (!ignoreClickOutside && parentEl) {
        // Move up to the parent element
        ignoreClickOutside = parentEl.classList.contains(ignoreClass);
        if (!ignoreClickOutside) {
            parentEl = parentEl.parentElement;
        }
    }

    // Return true if the closest parent has the specified class, otherwise false
    return ignoreClickOutside;
}

export function detectClickOutside(
    baseElement: HTMLElement | null,
    targetElement: HTMLElement | null,
    ignoreClass: string = ''
) {
    if (!baseElement || !targetElement) return false;

    const containsTarget = baseElement.contains(targetElement);

    if (!containsTarget) {
        if (!!ignoreClass) {
            return !hasNodeIgnoreClassName(targetElement, ignoreClass);
        }
        return true;
    }

    return false;
}
